import { S3 } from "../../../../../constants";
import { customRound } from "../../../../../utils/nutrition-util";

export const RECIPE_DETAILS_TYPES = ["recipe", "public-recipe"];

export const isRecipeDetailsType = (type) =>
  RECIPE_DETAILS_TYPES.includes(
    type === "public_recipe" ? "public-recipe" : type
  );

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const getImageUrl = (image) => {
  if (!image) return null;
  if (image.s3Path) return `${S3.PATH}${image.s3Path}`;
  return image.file ? `/api/file/${image.file}` : null;
};

export const normalizeRecipeDetails = (recipe) => {
  if (!recipe) return null;

  const nutrients = {
    proteins: toNumber(recipe.nutrients?.proteins),
    carbs: toNumber(recipe.nutrients?.carbs),
    fats: toNumber(recipe.nutrients?.fats),
    fibers: toNumber(recipe.nutrients?.fibers),
  };

  return {
    id: recipe._id,
    title: recipe.name || "",
    image: getImageUrl(recipe.image),
    prepTime: recipe.prepTime || "",
    difficulty: recipe.difficulty || "",
    foodType: recipe.foodType || "",
    servings: toNumber(recipe.servings),
    macrosBase: recipe.macrosBase || "",
    description: recipe.description || "",
    dietaryRestrictions: Array.isArray(recipe.dietaryRestrictions)
      ? recipe.dietaryRestrictions.filter(Boolean)
      : [],
    ingredients: Array.isArray(recipe.ingredients)
      ? recipe.ingredients.filter((ingredient) => ingredient?.name)
      : [],
    steps: Array.isArray(recipe.steps)
      ? recipe.steps.filter((step) => typeof step === "string" && step.trim())
      : [],
    nutrients,
    kcal: customRound(
      customRound(nutrients.proteins * 4) +
        customRound(nutrients.carbs * 4) +
        customRound(nutrients.fats * 9)
    ),
  };
};
